import { createAsyncThunk } from '@reduxjs/toolkit';
import { AppDispatch, RootState } from 'store';
import { DispatchError } from 'store/slices/authSlice';
import GenerateForecast from 'types/generateForecast/GenerateForecast';
import generateForecastApiService from 'api/generateForecastApiService';

const generateForecast = createAsyncThunk<
  void,
  number,
  {
    dispatch: AppDispatch;
    state: RootState;
    rejectValue: DispatchError;
  }
>(GenerateForecast.GENERATE_FORECAST, async (data: number) => {
  await generateForecastApiService.generateForecast(data);
});
export default generateForecast;
